import { render, staticRenderFns } from "./step-price-save.vue?vue&type=template&id=5f253f39&"
import script from "./step-price-save.vue?vue&type=script&lang=js&"
export * from "./step-price-save.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports